import { IconButton } from 'components/atoms/Buttons/IconButton';
import React from 'react';
import useStyle from './multipleSelect.style';

export interface MultipleSelectProps {
  filtersboxes?: string[];
}

export const MultipleSelect = ({ filtersboxes }: MultipleSelectProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <div className={classes.filtersBoxes}>
        {filtersboxes &&
          filtersboxes.map((filterbox, index) => (
            <div key={index} className={classes.filterBox}>
              <span>{filterbox}</span>
            </div>
          ))}
      </div>
      <IconButton onClick={null} variant="backless" icon="Plus" size="small" />
    </div>
  );
};
